/* ck-btn-sweep — directional hover sweep.
   1. Tags every bespoke section button with .ck-btn-sweep (SELECTORS below).
   2. Writes --sweep-x/-y/-size from the pointer's entry point on mouseenter.
   The CSS does the rest. .button--solid / .button--outline are handled in CSS
   directly and are not listed here.

   SELECTORS is the single source of truth for which bespoke buttons sweep.
   Add a class to include it. Deliberately NOT here: product cards, tiles,
   thumbnails, slider dots, nav/mega links, close buttons and drag handles —
   they are not action buttons and a sweep on them reads as a bug. */
(function(){
  var SELECTORS = [
    /* trade pages */
    '.ck-ts__pill', '.ck-tc__pill', '.ck-th__pill', '.ck-ts__say-pill',
    '.ck-ts__submit', '.ck-trade__submit', '.ck-ts__mh-cta', '.ck-ts__hero-btn', '.ck-ts__help-tel', '.ck-ts__help-chat',
    /* product / PDP */
    '.ck-pdp-desc__toggle', '.ck-pdp-reviews__cover-buy', '.ck-pdp-reviews__grid-more',
    '.ck-pdp-reviews__cover-floor-cta', '.ck-pdp-reviews__write-cta', '.ck-pdp-share__trigger',
    '.ck-obt__cta', '.ck-obt__cta-m', '.ck-obt__card-cta',
    /* brand / navigation CTAs */
    '.ck-brand-hero__cta', '.ck-brand-hero__cat-pill', '.ck-brand-subnav__pill',
    '.ck-crest-cinema__cta', '.ck-full-width-btn', '.ck-title__cta',
    /* chrome */
    '.footer-signup__btn', '.ck-footer__follow', '.header-search__submit',
    '.ckas__reset', '.ckcw__btn', '.chv__btn', '.ckc__submit',
    /* account — order-page reorder */ '.ck-reorder__btn',
    /* pills & chips (nav / filter / brand) — removable filter tokens
       (.pill--has-close) and display-badge spans are excluded */
    '.psearch-chip', '.ckbw__tab', '.ck-brand-hero__cat-pill',
    'a.pill:not(.pill--has-close):not(.pill--no-bg)', 'button.pill:not(.pill--has-close)',
    /* help pages: FAQ + delivery/returns/payment pills */ '.ckhp__pill', '.ckfaq__pill'
  ].join(',');

  /* mega-menu chips keep their own quiet fade — no sweep inside these */
  var MEGA = '[class*="newmega"], [class*="salemega"], .mega-menu, [class*="megacard"], [class*="ck-brand-megamenu"], [class*="ck-brands-mega"]';

  function onMove(e){
    var el = e.currentTarget;
    var r = el.getBoundingClientRect();
    if(!r.width || !r.height) return;
    var x = ((e.clientX - r.left) / r.width) * 100;
    var y = ((e.clientY - r.top) / r.height) * 100;
    var offCenter = Math.abs(((e.clientX - (r.left + r.width/2)) / (r.width/2)) * 50);
    el.style.setProperty('--sweep-x', x.toFixed(1) + '%');
    el.style.setProperty('--sweep-y', y.toFixed(1) + '%');
    el.style.setProperty('--sweep-size', (150 + offCenter * 2).toFixed(0) + '%');
  }
  function bind(el){
    if(el.dataset.ckSweep) return;
    el.dataset.ckSweep = '1';
    el.addEventListener('mouseenter', onMove);
    el.addEventListener('mouseleave', onMove);
  }
  function init(root){
    root = root || document;
    try{ root.querySelectorAll(SELECTORS).forEach(function(el){ if(el.closest(MEGA)) return; el.classList.add('ck-btn-sweep'); }); }catch(err){}
    root.querySelectorAll('.ck-btn-sweep, .button--solid, .button--outline').forEach(function(el){ if(el.closest && el.closest(MEGA)) return; bind(el); });
  }
  if(document.readyState !== 'loading'){ init(); }
  else { document.addEventListener('DOMContentLoaded', function(){ init(); }); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  window.ckBtnSweep = init;
})();
